module.exports = __webpack_public_path__ + "static/img/logo_web@1x.31c162f.png";


//////////////////
// WEBPACK FOOTER
// ./static/icon/logo_web@1x.png
// module id = EyBr
// module chunks = 0